import { render } from "./PlpProductsList.vue?vue&type=template&id=7fa0e63f"
import script from "./PlpProductsList.vue?vue&type=script&lang=js"
export * from "./PlpProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__